import React from 'react';
import { Link } from 'react-router-dom';

class ParticipantListDownloadPanel extends React.Component {
    render() {
        const tournament = this.props.tournament;

        const rrbridgeButton = (<span className="ml-1 mr-1">
            <a
            className="btn btn-primary btn-sm"
            href={'/api/tournaments/' + tournament.id + '/participants/download?format=RRBRIDGE'}
            role="button"
            target="_blank">RRBridge</a>
        </span>);

        const tcButton = (<span className="ml-1 mr-1">
            <a
            className="btn btn-primary btn-sm"
            href={'/api/tournaments/' + tournament.id + '/participants/download?format=TOURNAMENT_CALCULATOR'}
            role="button"
            target="_blank">Tournament Calculator</a>
        </span>);

        const paryButton = (<span className="ml-1 mr-1">
            <a
            className="btn btn-primary btn-sm"
            href={'/api/tournaments/' + tournament.id + '/participants/download?format=PARY'}
            role="button"
            target="_blank">Pary</a>
        </span>);

        const teamyButton = (<span className="ml-1 mr-1">
            <a
            className="btn btn-primary btn-sm"
            href={'/api/tournaments/' + tournament.id + '/participants/download?format=TEAMY'}
            role="button"
            target="_blank">Teamy</a>
        </span>);

        let buttons = [];

        if (tournament.type === 'INDIVIDUAL') {
            buttons = [paryButton];
        } else if (tournament.type === 'PAIRS') {
            buttons = [rrbridgeButton, tcButton, paryButton];
        } else {
            buttons = [teamyButton];
        }

        return (
            <div>
                <div className="form-group">
                    <span>Ściągnij listę startową: </span>
                    <span>{buttons}</span>
                </div>
                <div className="form-group">
                    <span>Ściągnij dane kontaktowe: </span>
                    <span>
                        <a className="btn btn-primary btn-sm"
                           href={'/api/tournaments/' + tournament.id + '/participants/emails'}
                           role="button"
                           target="_blank">e-maile</a>
                    </span>
                </div>
                <div className="form-group">
                    <span>Wyślij wiadomość do uczestników: </span>
                    <span>
                        <Link to={'/admin/tournaments/' + tournament.id + '/email-shipment'}><button className="btn btn-sm btn-primary">e-mail</button></Link>
                    </span>
                </div>
            </div>
        );
    }
}

export default ParticipantListDownloadPanel;



// WEBPACK FOOTER //
// ./components/ParticipantListDownloadPanel.js